<div nz-row style="font-size: 14px">
    <div nz-col nzSpan="4" class="ppl-read-label pt-2 pb-2">Authorized Units</div>
    <div nz-col nzSpan="4" class="pt-2 pb-2">{{authUtilizationData?.authUnit}}</div>

    <div nz-col nzSpan="4" class="ppl-read-label pt-2 pb-2">Used Units</div>
    <div nz-col nzSpan="4" class="pt-2 pb-2">{{authUtilizationData?.usedUnits}}</div>

    <div nz-col nzSpan="4" class="ppl-read-label pt-2 pb-2">Used Unit %</div>
    <div nz-col nzSpan="4" class="pt-2 pb-2">{{authUtilizationData?.usedPercentage}} 
        @if(authUtilizationData?.usedPercentage){
            <span>%</span>
        }
        </div>
</div>